<template>
    <div class="position-box">
        <div class="head">
            <img class="back" src="@/assets/icon_back.png" @click="back" alt="">
            <div class="title">{{$t('bzhl.dd')}}</div>
        </div>
        <!-- <ul class="tab-box">
          <li class="tab" :class="{active: tabIdx == 0}" @click="tab(0)">{{$t('c2c.dsh')}}</li>
          <li class="tab" :class="{active: tabIdx == 2}" @click="tab(2)">{{$t('langNew.ywc')}}</li>
          <li class="tab" :class="{active: tabIdx == 3}" @click="tab(3)">{{$t('c2c.ygq')}}</li>
        </ul> -->
        <div class="cotainer" @scroll="listenScroll">
          <ul class="item-ul">
            <li class="item-li" v-for="(item,index) in list" :key="index">
              <div class="item item-num">
                <div class="t1 order">{{item.truename}}</div>
                <div class="t2">{{item.add_time | timeGs}}</div>
              </div>
              <div class="item">
                <div class="t1">{{$t('c2c.mrje')}}</div>
                <div class="t2">{{item.money}} {{item.currency}}</div>
              </div>
              <div class="item">
                <div class="t1">{{$t('c2c.mrbz')}}</div>
                <div class="t2">{{item.currency}}</div>
              </div>
              <div class="item" v-if="tabIdx != 2">
                <div class="t1">{{$t('c2c.fkfs')}}</div>
                <div class="t2">{{item.paytype}}</div>
              </div>
              <div class="item" v-else>
                <div class="t1">{{$t('c2c.fkfs')}}</div>
                <div class="t2" @click="look">
                  <div class="look">{{$t('chongbi.ck')}}</div>
                  <img class="arrow" src="@/assets/arrow.png" alt="">
                </div>
              </div>
              <div class="item">
                <div class="t1">{{$t('c2c.ddzt')}}</div>
                <div class="t2" :class="{under: item.status == 0}">{{item.status | status}}</div>
              </div>
              <div class="remark"  v-show="item.status == -1">{{ item.remark_re }}</div>
            </li>
            <!-- <li class="item-li">
              <div class="item item-num">
                <div class="t1 order">{{$t('c2c.ddh')}}2024521</div>
                <div class="t2">2012-08-12</div>
              </div>
              <div class="item">
                <div class="t1">{{$t('c2c.mrje')}}</div>
                <div class="t2">521USDT</div>
              </div>
              <div class="item">
                <div class="t1">{{$t('c2c.mrbz')}}</div>
                <div class="t2">USDT</div>
              </div>
            </li> -->
            <!-- 暂无数据 -->
            <no-data v-show="isNoData"></no-data>
          </ul>
        </div>
        <!-- 返回顶部 -->
        <img id="goTop" class="go-top" @click="goTop" v-show="isGoTOP" src="@/assets/top.png" alt="">
        <!-- 详情弹窗 -->
        <div class="mask" v-show="isMask"></div>
        <div class="alert-wrap" v-show="isMask">
          <div class="alert-head">
            <div class="alert-title">请通过以下银行卡汇款</div>
            <img class="close" @click="close" src="@/assets/close-w.png" alt="">
          </div>
          <div class="t1">Name of payee:</div>
          <div class="t2">MIRTHE</div>
          <div class="t1">Account Number:</div>
          <div class="t2">4245 5124 2532 662</div>
          <div class="t1">Account type:</div>
          <div class="t2">公账</div>
          <div class="t1">Bank Name:</div>
          <div class="t2">汇丰银行</div>
          <div class="t1">Swift code:</div>
          <div class="t2">645d dh23 dk22</div>
          <div class="t1">Bank code:</div>
          <div class="t2">s55ds2ds@12</div>
          <div class="t1">Bank address:</div>
          <div class="t2">美国 旧金山 康美街道255号</div>
          <div class="t1">Beneficiary Address:</div>
          <div class="t2">美国 旧金山 康美街道255号</div>
          <div class="btn-copy" @click="copy">复制</div>
        </div>
    </div>
</template>

<script>
import noData from '@/components/noData.vue'
let that;
export default {
    name: 'c2cOrder',
    data () {
      return {
        token: '',
        tabIdx: 0,
        list: [],
        statusText: [],
        isMask: false,
        page: 1,
        isNoData: false,
        isGoTOP: false,
        curDataLength: 10,
      }
    },
    beforeCreate() {
      that = this;
    },
    created(){
      this.token = localStorage.getItem('token') || '';
      this.statusText = this.$t('status.statusText');
    },
    mounted() {
      this.getList();
    },
    methods: {
      back(){
        this.$router.push('/c2cCreate')
      },
      close(){
        this.isMask = false;
      },
      look(){
        this.isMask = true;
      },
      copy(){
        this.isMask = false;
      },
      tab(idx){
        this.tabIdx = idx;
        this.page = 1;
        this.list = [];
        this.getList()
      },
      getList(){
        let params = {
            tab: this.tabIdx,
            page: this.page
        }
        this.$ajax.get('/Web/ctocLog',{params}).then((res) => {
            let resData = res.data.data.data;
            // console.log(resData)
            if(resData.length > 0){
                this.list = this.list.concat(resData);
                this.curDataLength = resData.length;
            }else{
                this.curDataLength = resData.length;
            }
            if(this.list.length > 0){
                this.isNoData = false;
            }else{
                this.isNoData = true;
            }
        }).catch(function(err){
            console.log(err)
        })
      },
      listenScroll(e) {  //监听滚动
        let ele = e.srcElement ? e.srcElement : e.target;
        if(ele.scrollTop > 200){
            this.isGoTOP = true
        }else{
            this.isGoTOP = false
        }
        if (ele.scrollTop + ele.offsetHeight >= ele.scrollHeight) { //监听滚动到div底部
            if(this.curDataLength > 0){
                this.page ++;
                this.getList();
            }
        }
      },
      goTop(){
        $('.cotainer').animate({scrollTop:'0px'},'slow');
      }
    },
    filters: {
      status: function(val){
        if(val == -1){
            return that.statusText[0]
        }else if(val == 0){
            return that.statusText[1]
        }else if(val == 1){
            return that.$t('langNew.ywc')
        }else{
            return that.statusText[0]
        }
      }
    },
    components:{
      noData,
    },
    beforeDestroy(){

    }
}
</script>
<style scoped>
  .position-box{
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    width: 100%;
    height: auto;
    color: #cecece;
    font-size: .36rem;
    background: url('../assets/element-background.png') no-repeat center center;
    background-size: cover;
    overflow: hidden;
  }
  .head{
    position: fixed;
    top: 0;
    width: 100%;
    height: 1.2rem;
    padding: 0 .3rem;
    color: #fff;
    line-height: 1.2rem;
    box-sizing: border-box;
    text-align: center;
  }
  .head .back{
    position: absolute;
    left: .4rem;
    top: 50%;
    width: .3rem;
    margin-top: -.3rem;
  }
  .head .title{
    font-size: .56rem;
  }
  .head .text{
    font-size: .48rem;
  }
  .tab-box{
    position: absolute;
    left: .48rem;
    right: .48rem;
    top: 1.6rem;
    display: flex;
    align-items: center;
  }
  .tab-box .tab{
    position: relative;
    margin-right: 1rem;
    padding: 0 0 .4rem;
    color: #fff;
    font-size: .42rem;
  }
  .tab-box .tab.active::after{
    position: absolute;
    left: 50%;
    bottom: 0;
    content: '';
    width: 1rem;
    height: 0.09rem;
    background-color: #1553f0;
    border-radius: 0.05rem;
    transform: translateX(-50%);
  }
  .cotainer{
    position: absolute;
    top: 1.6rem;
    bottom: 0;
    width: 100%;
    background: transparent;
    overflow-y: scroll;
  }
  .item-ul{
    padding: 0 .32rem;
  }
  .item-ul .item-li{
    padding: .1rem .2rem .6rem;
    background: rgba(26,36,63,.4);
  	border-radius: 0.15rem;
  }
  .item-ul .item-li .item-num{
    margin-bottom: .3rem;
  }
  .item-ul .item-li .item{
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-top: .48rem;
  }
  .item-ul .item-li .item .t1{
    color: #d2d2d2;
    font-size: .4rem;
  }
  .item-ul .item-li .item .t2{
    display: flex;
    align-items: center;
    text-align: right;
  }
  .item-ul .item-li .item .look{
    color: #0060ff;
    font-size: .4rem;
  }
  .item-ul .item-li .item .arrow{
    width: .2rem;
    margin-left: .2rem;
  }
  .item-ul .item-li .item .order{
    color: #fff;
    font-size: .48rem;
  }
  .item-ul .item-li .item .under{
    color: #588bf8;
  }
  .item-ul .item-li .remark{
    color: #fff;
    font-size: .36rem;
    padding: .24rem 0 0;
  }
  .alert-wrap{
    position: absolute;
    top: 50%;
    left: .32rem;
    right: .32rem;
    z-index: 1000;
    padding: .4rem .5rem .8rem;
    background-color: #1a243f;
	  border-radius: 0.15rem;
    box-sizing: border-box;
    transform: translateY(-50%);
  }
  .alert-wrap .alert-head{
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .alert-wrap .alert-head .alert-title{
    color: #b5b5b5;
    font-size: .48rem;
  }
  .alert-wrap .alert-head .close{
    width: .4rem;
  }
  .alert-wrap .t1{
    padding-top: .3rem;
    color: #fff;
    font-size: .48rem;
  }
  .alert-wrap .t2{
    padding-top: .15rem;
    color: #fff;
    font-size: .48rem;
  }
  .alert-wrap .btn-copy{
    height: 1.2rem;
    margin-top: .8rem;
    color: #fff;
    font-size: .56rem;
    line-height: 1.2rem;
    background-color: #0060ff;
    border-radius: 0.2rem;
    text-align: center;
  }
</style>



// WEBPACK FOOTER //
// src/pages/c2cOrder.vue